import { createFileRoute } from '@tanstack/react-router'
import ConceptsGridSearch from 'Concept/components/Concept/search/ConceptsGridSearch'
import { claimTypesEnum } from 'User/utils/claims'
import { Suspense } from 'react'

import { PageSkeleton } from 'Common/components/skeletons'

import { Guard } from './-guard'

export const Route = createFileRoute('/concepts')({
    validateSearch: (search: Record<string, string>) => search,
    component: () => (
        <Guard claims={[claimTypesEnum.enum.opus_concept]}>
            <Suspense fallback={<PageSkeleton variant="grid" wrapper="page" />}>
                <ConceptsGridSearch />
            </Suspense>
        </Guard>
    ),
})
